(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/collections/draws.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/collections/draws.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.collections.Draws = Backbone.Collection.extend({
    model: svs.maltipset.models.Draw,
    currentDrawIndex: 0,
    initialize: function() {
      this.set(svs.maltipset.data.draws);
    },
    getDraw: function(drawNumber) {
      return this.find(function(draw) {
        return draw.get('drawNumber') == drawNumber;
      });
    },
    toJSON: function() {
      var json = Backbone.Collection.prototype.toJSON.apply(this);
      json.currentDrawIndex = this.currentDrawIndex;

      return json;
    },
    getFirstDraw: function() {
      return this.at(0);
    },
    getAllDraws: function() {
      return this.models;
    }
  });
})(Backbone, _, svs);

 })(window);